import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {
  ErmMasterRegType, ErmRegMainDto,
  ErmRegMainSearchParamDto, ErmRegMainViewDto, Page, SrmHospitalArbitraryDto,
} from "../../generated-model/model";
import {environment} from "../../environments/environment";
import {IgnoreNullHttpParams} from "../shared/commons/Ignore-null-http-params";
import {Observable} from "rxjs";
import {ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable({providedIn: "root"})
export class ErmRegMainResource {
  http = inject(HttpClient);

  public search(searchParam: ErmRegMainSearchParamDto, page: number, size: number): Observable<Page<ErmRegMainViewDto>> {
    return this.http.get<Page<ErmRegMainViewDto>>(`${environment.serverUrl}/api/erm-reg-main`, {
      params: IgnoreNullHttpParams.fromObject({
        ...searchParam,
        page: page,
        size: size
      }).toHttpParam()
    });
  }

  public searchErmMasterRegType(): Observable<ErmMasterRegType[]> {
    return this.http.get<ErmMasterRegType[]>(`${environment.serverUrl}/api/erm-reg-main/reg-type/criteria1-y`);
  }

  public findConsider(transId: number): Observable<ErmRegMainDto> {
    return this.http.get<ErmRegMainDto>(`${environment.serverUrl}/api/erm-reg-main/consider/${transId}`);
  }


  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ErmRegMainDto> {
    return this.http.get(`${environment.serverUrl}/api/erm-reg-main/${route.paramMap.get('id')}`);
  }
}
